import api from './api';

export async function getExtracts(
  type: 'deposit' | 'withdraw',
  status: 'pending' | 'canceled' | 'finish' | undefined,
  idUser: number | undefined,
  searchTxt: string,
  page: number,
  token: string,
): Promise<any> {
  let baseURL = '/extracts?limit=30';
  if (idUser) {
    baseURL = `${baseURL}&idUser=${idUser}`;
  }
  if (type) {
    baseURL = `${baseURL}&type=${type}`;
  }
  if (page) {
    baseURL = `${baseURL}&page=${page}`;
  }
  if (searchTxt) {
    baseURL = `${baseURL}&searchTxt=${searchTxt}`;
  }
  if (status) {
    baseURL = `${baseURL}&status=${status}`;
  }
  const response = await api.get(baseURL, {
    headers: {
      'x-access-token': token,
    },
  });

  return response.data;
}

export async function createTransactions(
  body: {
    value: number;
    type: 'deposit' | 'withdraw';
    idUser: number;
  },
  token: string,
): Promise<any> {
  const response = await api.patch('/extracts/transactions', body, {
    headers: {
      'x-access-token': token,
    },
  });

  return response;
}
